import React, { useState } from "react";
import {  FaMinus, FaPlus,  FaHeartbeat, FaMicroscope, FaNotesMedical, FaDna, FaLaptopMedical, FaCapsules, FaFlask, FaVial, FaPrescriptionBottle, FaUserMd, FaChartLine, FaUserCheck, FaFileMedical, FaProcedures, FaUsers, FaMedkit } from "react-icons/fa";

import Medpalm from "../../../assests/Healthcaretechnology/PersonalizedMedicineGenomics.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Genetic Testing & Risk Assessment",
        "description":
            "Utilize advanced genetic testing to analyze an individual’s DNA and assess predispositions to a wide range of diseases, including cancer, cardiovascular conditions, and neurological disorders. By identifying genetic risk factors early, individuals can take proactive steps toward disease prevention, such as lifestyle modifications, dietary adjustments, and routine medical screenings. Additionally, genetic counseling services can guide patients in understanding their risks and making informed healthcare decisions."
    },
    {
        "title": "Pharmacogenomics",
        "description":
            "Revolutionize medication management by analyzing a patient's genetic makeup to determine how they metabolize different drugs. Pharmacogenomics helps physicians personalize drug prescriptions to improve treatment efficacy, minimize adverse drug reactions, and enhance patient safety. This approach is especially beneficial for managing chronic conditions such as depression, hypertension, diabetes, and chronic pain, where standard medications may not work optimally for every patient. By leveraging pharmacogenomic insights, healthcare providers can optimize dosing, reduce trial-and-error prescribing, and improve therapeutic outcomes."
    },
    {
        "title": "Precision Oncology",
        "description":
            "Transform cancer treatment with genomic sequencing and biomarker analysis that enable highly targeted therapies. Precision oncology tailors treatments to the genetic profile of a patient’s tumor, ensuring more effective interventions while minimizing side effects. Instead of a one-size-fits-all approach, targeted therapies, such as immunotherapy and personalized chemotherapy, attack cancer cells based on their unique genetic mutations. This cutting-edge strategy leads to improved survival rates, better patient responses to treatment, and enhanced quality of life for cancer patients. Additionally, liquid biopsy techniques allow for continuous monitoring of tumor evolution, enabling timely adjustments to therapy."
    },
    {
        "title": "Rare Disease Diagnosis",
        "description":
            "Harness next-generation sequencing (NGS) and AI-driven genomic analysis to diagnose rare genetic disorders that traditional diagnostic methods often fail to detect. Many rare diseases have a genetic basis, and early detection through whole-exome or whole-genome sequencing can lead to more effective interventions, personalized treatments, and improved patient outcomes. Advanced bioinformatics tools analyze genetic variations and identify disease-causing mutations, helping physicians deliver precise and timely diagnoses. This is particularly beneficial for pediatric patients with congenital conditions, where early intervention can significantly improve quality of life."
    },
    {
        "title": "AI-Driven Genomic Analysis",
        "description":
            "Integrate artificial intelligence and machine learning to process massive genomic datasets with unprecedented speed and accuracy. AI-powered genomic analysis uncovers complex genetic correlations, predicts disease susceptibility, and accelerates the discovery of new therapies. Machine learning algorithms help identify biomarkers for conditions such as Alzheimer's, diabetes, and autoimmune diseases, leading to earlier detection and better-targeted interventions. AI also enhances genetic research by automating data interpretation, reducing the time required to translate genomic insights into actionable medical solutions."
    },
    {
        "title": "CRISPR & Gene Editing",
        "description":
            "Revolutionize medicine with CRISPR-Cas9 and other gene-editing technologies that allow precise modifications to DNA. CRISPR holds the potential to correct genetic mutations responsible for hereditary diseases such as cystic fibrosis, sickle cell anemia, and muscular dystrophy. Scientists are also exploring its applications in developing gene therapies for conditions like cancer, HIV, and neurodegenerative disorders. Additionally, CRISPR-driven advancements in regenerative medicine could lead to the creation of patient-specific stem cell therapies, opening new possibilities for treating previously incurable diseases. Ethical considerations and regulatory frameworks continue to evolve as gene editing moves closer to clinical applications."
    }
]


const features = [
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Cutting-edge genetic sequencing and analysis." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Advanced laboratory research for personalized therapies." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Expert genetic counseling for informed healthcare decisions." },
    { icon: <FaFlask className="text-[#2a627a] text-lg" />, text: "Precision medicine for targeted disease treatments." },
    { icon: <FaVial className="text-[#2a627a] text-lg" />, text: "Customized medication plans based on genetic profiles." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Pharmacogenomic insights for drug response predictions." }
];

const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Enhances disease prevention with genetic risk analysis." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Improves treatment outcomes with personalized therapies." },
    { icon: <FaUserCheck className="text-[#2a627a] text-lg" />, text: "Minimizes adverse drug reactions through tailored prescriptions." },
    { icon: <FaFileMedical className="text-[#2a627a] text-lg" />, text: "Accelerates early disease detection with genomic screening." },
    { icon: <FaPrescriptionBottle className="text-[#2a627a] text-lg" />, text: "Develops next-gen drugs based on genetic insights." },
    { icon: <FaProcedures className="text-[#2a627a] text-lg" />, text: "Revolutionizes cancer treatment with precision oncology." }
];
const cmsFeatures = [
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Genetic Counselor – Provides guidance on genetic risks and testing." },
    { icon: <FaUsers className="text-[#2a627a] text-lg" />, text: "Clinical Genomic Scientist – Analyzes DNA to diagnose and treat diseases." },
    { icon: <FaLaptopMedical className="text-[#2a627a] text-lg" />, text: "Bioinformatics Specialist – Uses AI and big data to interpret genetic data." },
    { icon: <FaMedkit className="text-[#2a627a] text-lg" />, text: "Pharmacogenomics Expert – Develops personalized medication strategies." },
    { icon: <FaDna className="text-[#2a627a] text-lg" />, text: "Gene Editing Researcher – Advances CRISPR and genetic modification technologies." },
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Molecular Biologist – Conducts research in genetic engineering and personalized medicine." }
];
const PMG = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  flex items-center justify-center"> Personalized Medicine & Genomics - <span className="text-gray-800"> HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        "Transforming healthcare with tailored treatments and genomic insights for precise, patient-centric care and improved outcomes."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Personalized Medicine & Genomics? </h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Personalized medicine and genomics use genetic data, AI-driven analytics, and advanced biotechnology to create tailored treatments for individual patients. Instead of a one-size-fits-all approach, personalized medicine considers a patient’s DNA, lifestyle, and environment to optimize treatment and disease prevention.

At HIKEHEALTH GS, we integrate cutting-edge genomics and AI-powered analytics to deliver precise, efficient, and personalized healthcare solutions for better patient outcomes.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Personalized Medicine & Genomics
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default PMG;
